module.exports = __webpack_public_path__ + "static/img/1-4.ac4167a.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-4.png
// module id = 258
// module chunks = 0